export class RandomStringUtil {
  public static generateRandomString(length = 6, source = '123456789ABCDEFGHIJKLMNPQRSTUVWXYZ'): string {
    let generatedString = '';
    for (let i = length; i > 0; --i) {
      generatedString += source[Math.floor(Math.random() * source.length)];
    }
    return generatedString;
  }
}
